// src/components/ServerDatabase/ServerTable.jsx
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { renderServerIcon } from './ServerCard';

const ServerTable = ({
  servers,
  onCopyIp,
  onOpenModal,
  onConnectRcon
}) => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  return (
    <div className="sdb-servers-table-container">
      <table className="sdb-servers-table">
        <thead>
          <tr>
            <th>{isEn ? 'Server / Address' : 'Сервер / Адрес'}</th>
            <th>{isEn ? 'Version / Core' : 'Версия / Ядро'}</th>
            <th>{isEn ? 'Online' : 'Онлайн'}</th>
            <th>{isEn ? 'Ping' : 'Пинг'}</th>
            <th>{isEn ? 'Last Audit' : 'Последний тест'}</th>
            <th style={{ textAlign: 'right' }}>{isEn ? 'Actions' : 'Действия'}</th>
          </tr>
        </thead>
        <tbody>
          {!servers || servers.length === 0 ? (
            <tr>
              <td colSpan={6} style={{ textAlign: 'center', padding: '22px 20px' }}>
                <div
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 9,
                    color: 'rgba(255, 255, 255, 0.5)',
                    fontSize: '0.92rem',
                    fontWeight: 500
                  }}
                >
                  <svg
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                    stroke="currentColor"
                    fill="none"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                  </svg>
                  <span>{isEn ? 'No servers found' : 'Серверов не найдено'}</span>
                </div>
              </td>
            </tr>
          ) : (
            servers.map((server) => {
              const fullAddress = server.port ? `${server.ip}:${server.port}` : server.ip;
              return (
                <tr key={server.id || fullAddress}>
                  <td>
                    <div className="sdb-table-server-cell">
                      <div className="sdb-table-server-avatar">
                        {renderServerIcon(server.iconType, server.iconUrl)}
                      </div>
                      <span className="sdb-table-server-ip">{fullAddress}</span>
                      <button
                        type="button"
                        className="sdb-server-copy-icon-btn"
                        onClick={() => onCopyIp(fullAddress)}
                        title={isEn ? 'Copy IP:PORT' : 'Скопировать IP:PORT'}
                      >
                        <svg viewBox="0 0 24 24" fill="none">
                          <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                        </svg>
                      </button>
                    </div>
                  </td>
                  <td>
                    <div style={{ fontFamily: 'var(--sdb-font-mono)', fontSize: '0.8rem', color: '#ffffff' }}>
                      {server.version}
                    </div>
                    <div style={{ fontSize: '0.74rem', color: 'var(--sdb-text-dimmed)' }}>
                      {server.core}
                    </div>
                  </td>
                  <td>
                    <span style={{ fontFamily: 'var(--sdb-font-mono)', fontWeight: 700 }}>
                      {server.players.toLocaleString()}
                    </span>
                    <span style={{ fontSize: '0.75rem', color: 'var(--sdb-text-dimmed)' }}>
                      {' '}/ {server.maxPlayers.toLocaleString()}
                    </span>
                  </td>
                  <td>
                    <span style={{ fontFamily: 'var(--sdb-font-mono)', color: 'var(--sdb-text-dimmed)', fontSize: '0.82rem' }}>
                      {server.ping} ms
                    </span>
                  </td>
                  <td>
                    <span style={{ fontFamily: 'var(--sdb-font-mono)', fontSize: '0.76rem', color: 'var(--sdb-text-dimmed)' }}>
                      {server.testedText}
                    </span>
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    <div style={{ display: 'inline-flex', gap: 6 }}>
                      <button
                        type="button"
                        className="sdb-action-btn-primary"
                        style={{ height: 32, padding: '0 12px', fontSize: '0.78rem' }}
                        onClick={() => onConnectRcon(fullAddress)}
                      >
                        <span>RCON</span>
                      </button>
                      <button
                        type="button"
                        className="sdb-action-btn-secondary"
                        style={{ height: 32, padding: '0 10px', fontSize: '0.78rem' }}
                        onClick={() => onOpenModal(server)}
                      >
                        <span>{isEn ? 'Info' : 'Инфо'}</span>
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ServerTable;